import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import axios from "axios";
import router from "../router";

Vue.use(Vuex);

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  withCredentials: false,
  credentials: "same-origin",
  mode: "no-cors",
  headers: {
    "content-type": "application/json; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS"
  }
});

// Configurate interceptor to redirect to login when it 401 is the returned status
api.interceptors.response.use((response) => {
  return response;
},
(error) => {
  if (error.response.status === 401 || error.response.status === 403) {
    error.redirectPending = true;

    if (error.response.status === 401) {
      let query = {};
      if (router.currentRoute.query
        && router.currentRoute.query.redirect) {
        query.redirect = router.currentRoute.query.redirect;
      }
      else if (router.currentRoute.fullPath != '/login') {
        query.redirect = router.currentRoute.fullPath;
      }

      // Unauthorized request was made
      router.push({
        path: "/login",
        query: query
      });
    }
    else if (error.response.status === 403) {
      router.push({name: 'forbidden'});
    }
  }
  
  return Promise.reject(error);
});

export default new Vuex.Store({
  state: {
    api: api,
    routes: null,
    user: null,
    loading: false,
    extraData: {},
    business: {
      assignedCompanies: [],
      b2bEmployees: [],
      currentCompany: undefined,
      companyProfiles: [],
      companyProfile: undefined,
      leadsSummary: [],
      loadingAssignedCompanies: false,
    },
  },
  mutations,
  actions
});
